import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginModel } from '../models/login.model';
import { BaseService } from './base.service';
import { catchError } from 'rxjs/operators';
import { AuthModel } from '../models/auth.model';
import { ConfigService } from './config.service';
import { environment } from './../../environments/environment';
import { ChangePasswordModel } from './../models/auth.model';
import { ResponseData } from './../models/model';

@Injectable()
export class AuthService extends BaseService {
  public auth: AuthModel;
  public redirectUrl: string;

  private baseUrl;

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getBaseUrl();
  }

  login(model: LoginModel): Observable<ResponseData<any>> {
    const headers = this.getHeaders(true);
    return this.http.post<ResponseData<any>>(
      this.baseUrl + this.configService.url.auth.signin,
      model,
      { headers }
    );
  }

  changePassword(model: ChangePasswordModel): Observable<ResponseData<any>> {
    const headers = this.getHeaders(true);
    return this.http
      .post<ResponseData<any>>(
        this.baseUrl + this.configService.url.auth.changePassword,
        model,
        { headers }
      )
      .pipe(
        catchError(this.handleError('changePassword', new ResponseData<any>()))
      );
  }

  logout(): Observable<ResponseData<any>> {
    const headers = this.getHeaders(true);
    return this.http
      .post<ResponseData<any>>(
        this.baseUrl + this.configService.url.auth.logout,
        {},
        { headers }
      )
      .pipe(
        catchError(this.handleError('logout', new ResponseData<any>()))
      );
  }

  getUserInfoLocal(): AuthModel {
    const currentAuth = sessionStorage.getItem('current_user');
    this.auth = JSON.parse(currentAuth) as AuthModel;
    if (!this.auth || !this.auth.username) {
      this.auth = new AuthModel();
    }
    return this.auth;
  }

  getExtenalUrlIndex(currentUrl: string): string {
    const extenalUrl =
      currentUrl === '/' || currentUrl === '/home'
        ? this.configService.url.home.index
        : `/api${currentUrl}/index`;
    return extenalUrl.replace('//', '/').replace('-', '').toLowerCase();
  }

  getExtenalUrlApi(currentUrl: string): string {
    const extenalUrl =
      currentUrl === '/' || currentUrl === '/home'
        ? this.configService.url.home.index
        : `/api${currentUrl}`;
    return extenalUrl.replace('//', '/').replace('-', '').toLowerCase();
  }

  public hasPermission(url: string): boolean {
    if (!this.auth || !this.auth.listResourceApi) {
      this.auth = this.getUserInfoLocal();
      if (!this.auth || !this.auth.listResourceApi) {
        return false;
      }
    }

    const currentUrl = url.toLowerCase();
    const currentUrlIndex = (currentUrl + '/index').replace('//', '/');
    const extenalUrlApi = this.getExtenalUrlApi(currentUrl);
    const extenalUrlIndex = this.getExtenalUrlIndex(currentUrl);
    const index = this.auth.listResourceApi.findIndex((val, index) => {
      const linkApi = val.toLowerCase();
      return (
        linkApi === currentUrl ||
        linkApi === extenalUrlIndex ||
        linkApi === extenalUrlApi ||
        currentUrl.indexOf(linkApi) === 0 ||
        currentUrlIndex.indexOf(linkApi) === 0 ||
        extenalUrlApi.indexOf(linkApi) === 0 ||
        extenalUrlIndex.indexOf(linkApi) === 0
      );
    });
    return (
      currentUrl === '/signin' || currentUrl === '/changepassword' || index > -1
    );
  }
}
